import { Button } from "@/components/ui/button";
import { Mail, Github, Linkedin, Instagram } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Hero = () => {
  const { t } = useLanguage();
  
  return (
    <section
      id="hero"
      className="min-h-screen flex items-center justify-center relative overflow-hidden pt-16"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10 lg:gap-12 items-center max-w-7xl mx-auto">
          {/* Left: Profile Image */}
          <div className="flex justify-center md:justify-end">
            <div className="relative w-full max-w-[240px] sm:max-w-[280px] md:max-w-[320px] lg:max-w-[380px]">
              <img
                src="/profile-dio-3.jpg"
                alt="Widyo Tri Cahya Utomo"
                className="relative w-full aspect-square object-cover object-[center_20%] rounded-2xl shadow-medium"
                width={380}
                height={380}
                loading="eager"
                decoding="async"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6 text-center md:text-left">
            <div>
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2">
                <span className="text-primary">{t.hero.greeting}</span>{" "}
                <span className="whitespace-nowrap">{t.hero.name}</span>
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl text-primary font-medium mb-2 sm:mb-3">{t.hero.nickname}</p>
              <p className="text-sm sm:text-base md:text-lg text-muted-foreground">
                {t.hero.title}
              </p>
            </div>

            <p className="text-xs sm:text-sm md:text-base text-foreground leading-relaxed max-w-xl mx-auto md:mx-0">
              {t.hero.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 justify-center md:justify-start">
              <Button size="lg" className="shadow-soft w-full sm:w-auto text-sm sm:text-base hover-glow transition-smooth" asChild>
                <a href="/Widyo_TCU_Data_DevOps.pdf" download="Widyo_Tri_Cahya_Utomo_CV.pdf" target="_blank" rel="noopener noreferrer">{t.hero.downloadResume}</a>
              </Button>
              <Button variant="outline" size="lg" className="w-full sm:w-auto text-sm sm:text-base hover-glow transition-smooth" asChild>
                <a href="#contact">Let's Connect</a>
              </Button>
            </div>

            <div className="flex gap-1 sm:gap-2 pt-2 sm:pt-3 md:pt-4 pb-16 md:pb-0 justify-center md:justify-start">
              <a
                href="mailto:widyo1107@gmail.com"
                className="inline-flex h-11 w-11 items-center justify-center text-muted-foreground hover:text-primary transition-colors"
                aria-label="Email"
              >
                <Mail className="h-4 w-4 sm:h-5 sm:w-5" />
              </a>
              <a
                href="https://linkedin.com/in/widyo11"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-11 w-11 items-center justify-center text-muted-foreground hover:text-primary transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-4 w-4 sm:h-5 sm:w-5" />
              </a>
              <a
                href="https://github.com/tcuber11"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-11 w-11 items-center justify-center text-muted-foreground hover:text-primary transition-colors"
                aria-label="GitHub"
              >
                <Github className="h-4 w-4 sm:h-5 sm:w-5" />
              </a>
              <a
                href="https://www.instagram.com/tcu98"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-11 w-11 items-center justify-center text-muted-foreground hover:text-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4 sm:h-5 sm:w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
